/* global fetch */

import { config } from '../config';
import { APIResponse, fetchAPI, headers, SpanTag, stleaf } from '../helpers';

export interface Folders {
  id: string;
  name: string;
  organisationId: string;
  createdBy: string;
  createdAt: string;
  sortOrder: number;
}

type GetFoldersResponse = Promise<APIResponse<Folders[]>>;
/** When `organisationId` is set, folders for that workspace are returned (same primary org + user scope). */
export const getFolders = (
  st: SpanTag,
  organisationId?: string,
): GetFoldersResponse => {
  const url = new URL(`${config.API_URL}/v1/map-folders/`);
  if (organisationId) {
    url.searchParams.set('organisationId', organisationId);
  }
  return fetchAPI(stleaf(st, 'yiet0r'), url, {
    method: 'GET',
    credentials: 'include',
    headers,
  }) as GetFoldersResponse;
};

type PostFolderResponse = Promise<APIResponse<Folders>>;
export const postFolder = (st: SpanTag, body: { name: string }): PostFolderResponse => {
  const url = `${config.API_URL}/v1/map-folders/`;
  return fetchAPI(stleaf(st, 'ja1ees'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
    body: JSON.stringify(body),
  }) as PostFolderResponse;
};

type DeleteFolderResponse = Promise<APIResponse<void>>;
export const deleteFolder = (st: SpanTag, id: string): DeleteFolderResponse => {
  const url = `${config.API_URL}/v1/map-folders/${id}`;
  return fetchAPI(stleaf(st, 'upib6z'), url, {
    method: 'DELETE',
    credentials: 'include',
    headers,
  }) as DeleteFolderResponse;
};

type RenameFolderResponse = Promise<APIResponse<void>>;
export const renameFolder = (st: SpanTag, id: string, body: { name: string }): RenameFolderResponse => {
  const url = `${config.API_URL}/v1/map-folders/${id}`;
  return fetchAPI(stleaf(st, 'ko8kah'), url, {
    method: 'PUT',
    credentials: 'include',
    headers,
    body: JSON.stringify(body),
  }) as RenameFolderResponse;
};

type ReorderFoldersResponse = Promise<APIResponse<void>>;
export const reorderFolders = (
  st: SpanTag,
  body: { folderIds: string[] },
): ReorderFoldersResponse => {
  const url = `${config.API_URL}/v1/map-folders/reorder`;
  return fetchAPI(stleaf(st, 'mfre01'), url, {
    method: 'PUT',
    credentials: 'include',
    headers,
    body: JSON.stringify(body),
  }) as ReorderFoldersResponse;
};
